import React from 'react';
import { Dropdown } from 'antd';

import type { IBaseComponentProps } from 'infrastructure/interfaces';

export interface IBaseDropdownProps extends IBaseComponentProps {
  content?: React.ReactNode;
  trigger?: ('click' | 'hover' | 'contextMenu')[];
  placement?:
    | 'topLeft'
    | 'topCenter'
    | 'topRight'
    | 'bottomLeft'
    | 'bottomCenter'
    | 'bottomRight'
    | 'top'
    | 'bottom';
  offset?: [number | `${number}%`, number | `${number}%`];
  onOpenChange?: (
    state: boolean,
    info: {
      source: 'trigger' | 'menu';
    },
  ) => void;
  destroyPopupOnHide?: boolean;
  transitionName?: string;
  open?: boolean;
  zIndex?: number;
  getPopupContainer?: (triggerNode: HTMLElement) => HTMLElement;
}

const BaseDropdown: React.FC<IBaseDropdownProps> = (props) => {
  const {
    children,
    content,
    placement,
    offset,
    onOpenChange,
    destroyPopupOnHide = true,
    transitionName,
    open,
    trigger = ['click'],
    zIndex = 100,
    getPopupContainer,
  } = props;
  return (
    <Dropdown
      open={open}
      align={{ offset }}
      placement={placement}
      trigger={trigger}
      dropdownRender={() => {
        return <div>{content}</div>;
      }}
      transitionName={transitionName}
      onOpenChange={onOpenChange}
      destroyPopupOnHide={destroyPopupOnHide}
      overlayStyle={{ zIndex }}
      getPopupContainer={getPopupContainer}
    >
      {children}
    </Dropdown>
  );
};

export default BaseDropdown;
